import i18n from "../i18n";

export function formatError(result) {
    if (result.data) {
        return result.data.join("\r\n");
    }
    if (result.message) {
        return result.message;
    }
    return result.error;
}
export function formatBackendError(err) {
    try {
        if (err?.data && Array.isArray(err.data)) {
            return err.data.map((error) => {
                const [field, message] = error.split(':');
                return `${i18n.t(`columns.${field}`)}: ${message}`;
            });
        }

        if (typeof err === 'string') {
            return [err];
        }

        if (err?.message) {
            return [err.message];
        }

        if (err?.error) {
            return [i18n.t('errors.' + err.error)];
        }
    } catch (e) {
        console.warn('Unexpected error format:', err, e);
    }

    return [i18n.t('errors.unknown')];
}


export function hasError(result) {
    return result.error !== "OK";
}
